import script from "./LeadsAddView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsAddView.vue?vue&type=script&setup=true&lang=js"

import "./LeadsAddView.vue?vue&type=style&index=0&id=c5427a3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5427a3a"]])

export default __exports__